module.exports = __webpack_public_path__ + "static/img/3.05972c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news19/3.png
// module id = 2Yly
// module chunks = 1